import { Card, Divider, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { Fragment } from "react";

import { TB_TEST_TYPE_DETAIL_DESCRIPTIONS, TB_TEST_TYPE_LABELS, TB_TEST_TYPES } from "../constants";

export function AcceptedTbTestTypes() {
  return (
    <Stack spacing={3}>
      <Card variant="tertiary" sx={{ paddingY: 1 }}>
        <CardContent>
          <Stack spacing={6}>
            {TB_TEST_TYPES.map((testType, index) => (
              <Fragment key={testType}>
                {index > 0 && <Divider />}
                <Stack spacing={3}>
                  <Text>{TB_TEST_TYPE_LABELS[testType]}</Text>
                  <Text variant="body2" sx={{ color: (theme) => theme.palette.text.tertiary }}>
                    {TB_TEST_TYPE_DETAIL_DESCRIPTIONS[testType]}
                  </Text>
                </Stack>
              </Fragment>
            ))}
          </Stack>
        </CardContent>
      </Card>

      <Text variant="body2" sx={{ color: (theme) => theme.palette.text.tertiary }}>
        Test requirements and validity may vary by workplace.
      </Text>
    </Stack>
  );
}
